import i18n from "i18n";

export const filterTypeMap = {
  enabled: {
    name: "enabled",
    type: "twoOption",
    default_value: undefined,
  },
  ordering: {
    name: "ordering",
    type: "twoOption",
    default_value: "-created_at",
  },
};

export const filterDataSource = [
  {
    type: "twoOption",
    options: [
      {
        selected: false,
        label: i18n.t("enabled"),
        value: true,
      },
      {
        selected: false,
        label: i18n.t("disabled"),
        value: false,
      },
    ],
    label: i18n.t("product.status"),
    firstOptionLabel: i18n.t("all.m"),
    name: "enabled",
  },
];